import React from 'react';

import { PageLink, PathLink, AnchorScrollLink, PageAnchorLink } from '../ui';

export const NavLink = ({ _type, ...rest }) => {
  const LinkComponent = () => {
    switch (_type) {
      case 'pageLink':
        return <PageLink {...rest} />;
      case 'pathLink':
        return <PathLink {...rest} />;
      case 'anchorLink':
        return <AnchorScrollLink {...rest} />;
      case 'pageAnchorLink':
        return <PageAnchorLink {...rest} />;
      default:
        return null;
    }
  };
  return <LinkComponent />;
};
